import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import Notfound from "@components/Not-Found-small";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { clientGetLocation } from "@services/location.service";
import Loader from "@components/common/Loader";
import { NavLink } from "react-router-dom";
import { months } from "@_common/month";
import { years } from "@_common/year";
import InputField from "@_common/InputRuleFeild";
import { addTaskLicenses } from "@services/license.service";
import { adminGetListManagementGroupCode } from "@services/list-management.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import PaginationPage from "@components/pagination/pagination";

export default function MasterAddToTracker(props: any) {
  let params = useParams();
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [activeTab, setActiveTab] = useState(1);
  const [locationList, setLocationList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [subVendorList, setSubVendorList] = useState([]);

  const [licenseList, setLicenseList] = useState([]);

  const [functions, setFunctions] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState<any>({});
  const [selectedVendor, setSelectedVendor] = useState<any>([]);
  const [selectedSubVendor, setSelectedSubVendor] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(true);

  const [submitLoading, setSubmitLoading] = useState(false);

  const [month, setMonth] = useState<string | number | any>("");
  const [year, setYear] = useState<string | number | any>("");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    var date = new Date();
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getLocations();
      if (params.page_no) {
        setLocationPageNo(parseInt(params.page_no));
      }
      if (params.limit) {
        setLocationLimit(parseInt(params.limit));
      }
    }
    setMonth(date.getMonth() + 2);
    setYear(date.getFullYear());
  }, [props.permissionAPITriggered, window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [locationTotalCount, setLocationTotalCount] = useState(0);
  const [locationLimit, setLocationLimit] = useState(20);
  const [locationPageNo, setLocationPageNo] = useState(1);

  const handleLocationChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleLocationChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const getLocations = async () => {
    try {
      let payload: any = {
        page_no: locationPageNo,
        page_size: locationLimit,
        is_active: true,
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        let filtered = getValue(resp, `data.locations`, []).filter(
          (item: object) => getValue(item, `is_active`, false)
        );

        setLocationList(
          getValue(filtered, `length`, 0) > 0 &&
            filtered.map((item: object) => ({
              ...item,
              status: getValue(item, `is_active`, false)
                ? "Active"
                : "Inactive",
              city_name: getValue(item, `city.name`, ""),
              value: getValue(item, `location_name`, ""),
              label: getValue(item, `location_name`, ""),
            }))
        );
        getLicenses();
        handleSelectLocation(getValue(filtered, `[${0}].id`, ""));
        // selectedLocation.push(getValue(filtered, `[${0}].id`, ''));
        // getFunctions(getValue(filtered, `[${0}].id`, ""));
        setCurrentLocation(getValue(filtered, `[${0}].id`, ""));
        setLocationTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getLicenses = async () => {
    try {
      setIsLoading1(true);
      let resp = await adminGetListManagementGroupCode("license-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        setLicenseList(list);
        setIsLoading1(false);
      } else {
        setIsLoading1(false);
      }
    } catch (error) {
      setIsLoading1(false);
    }
  };

  const handleSubmit = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
    try {
      if (Object.keys(selectedLocation).length > 0) {
        let payload = {
          checkpoint_ids: selectedIDs,
          assign_values: Object.entries(selectedLocation).map(
            (loc: any, _index) => ({
              location_id: loc[0],
              license_type_ids: loc[1],
            })
          ),
        };
        let checkEmpty = getValue(payload, `assign_values`, []).filter(
          (item: any) => getValue(item, `license_type_ids.length`, 0) > 0
        );
        if (getValue(checkEmpty, `length`, 0) > 0) {
          if (selectedIDs.length > 0) {
            setSubmitLoading(true);
            let resp = await addTaskLicenses(payload);
            if (resp) {
              setSubmitLoading(false);
              toast.success(getValue(resp, `message`, ""));
              navigate(`/repository/checkpoint/license`);
            } else {
              setSubmitLoading(false);
            }
          } else {
            setSubmitLoading(false);
            toast.error("All fields are mandatory");
          }
        } else {
          toast.error("Please select license type");
        }
      } else {
        setSubmitLoading(false);
        toast.error("All fields are mandatory");
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const [all, setAll] = useState("false");
  const handleChangeAllVendor = (value: string) => {
    setAll(value);
    if (value === "true") {
      let list = subVendorList.map((item: object) => getValue(item, `id`, ""));
      setSelectedSubVendor(list);
    } else {
      setSelectedSubVendor([]);
    }
  };

  const [currentLocation, setCurrentLocation] = useState("");
  const handleSelectLocation = async (id: string) => {
    setCurrentLocation(id);
    if (Object.keys(selectedLocation).includes(id)) {
      // delete selectedLocation[id];
      // setSelectedLocation({ ...selectedLocation });
    } else {
      selectedLocation[id] = [];
      setSelectedLocation({ ...selectedLocation });
    }
    setSubVendorList([]);
    // let selectedLocations = selectedLocation.filter(
    // 	(item: string) => item === id
    // );
    // if (selectedLocations.length > 0) {
    // 	let filtered = selectedLocation.filter((item: string) => item !== id);
    // 	setSelectedLocation(filtered);
    // } else {
    // 	selectedLocation.push(id);
    // 	setSelectedLocation([...selectedLocation]);
    // }
  };

  const handleSelectLocationOnClick = async (id: string) => {
    setCurrentLocation(id);
  };

  const handleSelectSubVendor = (id: string) => {
    if (Object.keys(selectedLocation).length > 0) {
      let selectedSubVendors = selectedLocation[currentLocation].filter(
        (item: string) => item === id
      );
      if (selectedSubVendors.length > 0) {
        let filtered = selectedLocation[currentLocation].filter(
          (item: string) => item !== id
        );
        selectedLocation[currentLocation] = filtered;
        setSelectedLocation({ ...selectedLocation });
      } else {
        selectedLocation[currentLocation].push(id);
        setSelectedLocation({ ...selectedLocation });
      }
    } else {
      toast.error("Please select location");
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
  return (
    <>
      <Layout>
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "repository_checkpoint_company_master"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <section className="inner-page-navigation-with-back-cta-buttons position-relative">
              <div className="container-fluid  d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center py-3">
                  <NavLink to="/repository/checkpoint/master">
                    <img
                      src="/images/back-link.svg"
                      className="img-fluid"
                      height={24}
                      width={24}
                    />
                  </NavLink>
                  <p className="inner-page-navigation-text">Add to Tracker22</p>
                </div>
              </div>
            </section>
            <div className="release-checkpoint  d-flex justify-content-between align-items-center">
              <h4>Selected {getValue(selectedIDs, `length`, 0)} Checkpoints</h4>
              {getValue(props, `permissions`, []).includes("update") && (
                <div>
                  {submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                      onClick={handleSubmit}
                    >
                      Assign
                    </button>
                  )}
                </div>
              )}
            </div>
            {activeTab === 1 ? (
              <>
                {/* Location */}
                <div className="map-vendor-wrapper w-100">
                  <div className="map-vendor__details d-flex align-items-flex-start m-0">
                    <div className="map-vendor__check">
                      <div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
                        <h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
                          Location Name
                        </h5>
                        <div className="form-group d-flex align-iems-center m-0"></div>
                      </div>
                      <div className="map-vendor__checklist my-3">
                        {isLoading || !props.permissionAPITriggered ? (
                          <Loader />
                        ) : getValue(locationList, `length`, 0) > 0 ? (
                          locationList.map((searchObj, index) => {
                            return (
                              <>
                                <div
                                  className={`release-details d-flex cursor-pointer
														${
                              currentLocation === getValue(searchObj, `id`, "")
                                ? "background_selected"
                                : ""
                            }
														`}
                                  onClick={() =>
                                    handleSelectLocation(
                                      getValue(searchObj, `id`, "")
                                    )
                                  }
                                >
                                  <label
                                    className="position-relative form-group d-flex align-items-center cursor-pointer mb-0"
                                    htmlFor={`location-${index}`}
                                    key={`location-${index}`}
                                  >
                                    <div>
                                      <input
                                        type="radio"
                                        // className="default-checkbox cursor-pointer"
                                        className="new-radio"
                                        id={`location-${index}`}
                                        // checked={Object.keys(
                                        // 	selectedLocation
                                        // ).includes(getValue(searchObj, `id`, ""))}
                                        checked={
                                          currentLocation ===
                                          getValue(searchObj, `id`, "")
                                        }
                                        onChange={() =>
                                          handleSelectLocation(
                                            getValue(searchObj, `id`, "")
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="cursor-pointer">
                                      <p
                                        className="mx-3"
                                        onClick={() =>
                                          handleSelectLocation(
                                            getValue(searchObj, `id`, "")
                                          )
                                        }
                                      >
                                        {" "}
                                        {getValue(
                                          searchObj,
                                          `location_name`,
                                          ""
                                        )}
                                      </p>
                                      <div className="mx-3">
                                        {getValue(
                                          selectedLocation,
                                          `[${getValue(
                                            searchObj,
                                            `id`,
                                            ""
                                          )}].length`,
                                          0
                                        )}{" "}
                                        Functions selected
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <>
                            {Object.keys(params).length !== 0 ? (
                              <>
                                <Notfound />
                              </>
                            ) : (
                              <Notfound />
                            )}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Function */}
                    <div className="map-vendor__check">
                      <div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
                        <h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
                          License Type
                        </h5>
                        <div className="form-group d-flex align-iems-center m-0"></div>
                      </div>
                      <div className="map-vendor__checklist my-3">
                        {isLoading1 || !props.permissionAPITriggered ? (
                          <Loader />
                        ) : getValue(licenseList, `length`, 0) > 0 ? (
                          licenseList.map((searchObj, index) => {
                            return (
                              <div className="release-details d-flex">
                                <label
                                  className="position-relative form-group d-flex align-items-center cursor-pointer mb-0"
                                  htmlFor={`vendor-${index}`}
                                  key={`vendor-${index}`}
                                >
                                  <div>
                                    <input
                                      type="checkbox"
                                      className="default-checkbox"
                                      id={`vendor-${index}`}
                                      checked={
                                        getValue(
                                          selectedLocation,
                                          `[${currentLocation}].length`,
                                          0
                                        ) > 0 &&
                                        selectedLocation[
                                          currentLocation
                                        ].includes(
                                          getValue(searchObj, `id`, "")
                                        )
                                      }
                                      onChange={() =>
                                        handleSelectSubVendor(
                                          getValue(searchObj, `id`, "")
                                        )
                                      }
                                    />
                                    <div className="custom-checkbox--bg-red">
                                      <img
                                        src="/images/uploaded-details/tick.svg"
                                        className="img-fluid uploaded-tick"
                                      />
                                    </div>
                                  </div>
                                </label>
                                <div
                                  className=" d-flex cursor-pointer"
                                  onClick={() =>
                                    handleSelectSubVendor(
                                      getValue(searchObj, `id`, "")
                                    )
                                  }
                                >
                                  <p
                                    className="mx-3"
                                    // onClick={() =>
                                    // 	getSubVendor(getValue(searchObj, `id`, ""))
                                    // }
                                  >
                                    {" "}
                                    {getValue(searchObj, `text`, "")}
                                  </p>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <>
                            {Object.keys(params).length !== 0 ? (
                              <>
                                <Notfound />
                              </>
                            ) : (
                              <Notfound />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="footer-wrapper-new w-100">
                    <img
                      src="/images/footer-image.svg"
                      className="img-fluid footer-image"
                    />
                    <div className="footer-wrapper d-flex justify-content-between">
                      {locationTotalCount > 10 ? (
                        <PaginationPage
                          totalCount={locationTotalCount}
                          limit={locationLimit}
                          pageNumber={locationPageNo}
                          handleChangePagination={
                            handleLocationChangePagination
                          }
                          handleChangeLimit={handleLocationChangeLimit}
                        />
                      ) : (
                        <p className="show-rows-count mt-3 d-flex">
                          Total Count:&nbsp;&nbsp;{" "}
                          <p style={{ color: "rgb(13, 110, 253)" }}>
                            {locationTotalCount}
                          </p>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="user-details-wrapper m-0">
                <div className="checkpoint-active-details-wrapper__form-wrapper">
                  <div className="checkpoint-active-details-wrapper__form-content">
                    <Row>
                      <Col md="6">
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Month
                          </label>
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Choose Month"
                            className="users-form-control"
                            name="month"
                            id="month"
                            options={months}
                            value={months.filter(
                              (item: object) =>
                                getValue(item, `value`, "") == month
                            )}
                            onChange={(e: any) => setMonth(e.value)}
                            label="Month"
                            // validator={simpleValidator}
                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Year
                          </label>
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Choose Month"
                            className="users-form-control"
                            name="month"
                            id="month"
                            options={years}
                            value={years.filter(
                              (item: object) =>
                                getValue(item, `value`, "") == year
                            )}
                            onChange={(e: any) => setYear(e.value)}
                            label="Year"
                            // validator={simpleValidator}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Layout>
    </>
  );
}
